import Swiper, { Autoplay, Pagination } from 'swiper'
import { mdBreakpoint } from "../utils/breakpoints"
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

Swiper.use([Autoplay, Pagination])

function initReviewsCarousel() {

  const reviewsBlocks = Array.from(document.querySelectorAll('.js-reviews'))

  reviewsBlocks.forEach(reviewsBlock => {

    let swiper = Swiper
    let swiperInitialised = false
    const swiperEl = reviewsBlock.querySelector('.js-reviews-swiper')
    const paginationEl = reviewsBlock.querySelector('.js-reviews-pagination')

    const initSwiper = () => {
      swiperInitialised = true

      swiper = new Swiper(swiperEl, {
        speed: 800,
        grabCursor: true,
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: true,
        watchOverflow: true,
        autoplay: {
          delay: 8000
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 24,
            centeredSlides: false,
            centerInsufficientSlides: true,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 48,
            centeredSlides: false,
            centerInsufficientSlides: true,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 48,
            centeredSlides: false,
            centerInsufficientSlides: true,
          }
        }
      })
    }

    const destroySwiper = () => {
      swiper.destroy()
      paginationEl.style.display = "none"
      swiperInitialised = false
    }

    //Invoke on page load
    if (mdBreakpoint.matches &&
      swiperInitialised === false &&
      reviewsBlock.classList.contains('-carousel-desktop')
    ) {
      initSwiper()
    } else if (!mdBreakpoint.matches &&
      swiperInitialised === false &&
      reviewsBlock.classList.contains('-carousel-mobile')
    ) {
      initSwiper()
    }

    //Init or destroy after resize
    const initOrDestroy = () => {

      //Check if swiper should be destroyed
      if (mdBreakpoint.matches &&
        swiperInitialised === true &&
        !reviewsBlock.classList.contains('-carousel-desktop')
      ) {
        destroySwiper()
      } else if (!mdBreakpoint.matches &&
        swiperInitialised === true &&
        !reviewsBlock.classList.contains('-carousel-mobile')
      ) {
        destroySwiper()
      }

      //Check if swiper should be initialised
      if (mdBreakpoint.matches &&
        swiperInitialised === false &&
        reviewsBlock.classList.contains('-carousel-desktop')
      ) {
        initSwiper()
        paginationEl.style.display = "flex"
        swiperInitialised = true
      } else if (!mdBreakpoint.matches &&
        swiperInitialised === false &&
        reviewsBlock.classList.contains('-carousel-mobile')
      ) {
        initSwiper()
        paginationEl.style.display = "flex"
        swiperInitialised = true
      }
    }

    const invokeAfterResize = () => {
      let rtime
      let timeout = false
      const timeoutDuration = 200

      window.addEventListener('resize', () => {
        rtime = new Date()
        if (timeout === false) {
          timeout = true
          setTimeout(resizeEnd, timeoutDuration)
        }
      })

      const resizeEnd = () => {
        if (new Date() - rtime < timeoutDuration) {
          setTimeout(resizeEnd, timeoutDuration)
        } else {
          timeout = false

          //Invoke initOrDestroy after resize
          initOrDestroy()
        }
      }
    }
    invokeAfterResize()

  })
}
initReviewsCarousel()

function initReviewsStarsAnimation() {

  const reviewsCards = Array.from(document.querySelectorAll('.js-reviews-card'))

  reviewsCards.forEach(reviewsCard => {

    const starItems = Array.from(reviewsCard.querySelectorAll('.js-reviews-star-item'))

    const tl = gsap.timeline({
      scrollTrigger: {
        toggleActions: 'play none none none',
        start: 'top bottom',
        trigger: reviewsCard,
      }
    })

    tl.to(starItems, {
      opacity: 1,
      duration: 0.4,
      stagger: 0.2,
    })

  })
}
initReviewsStarsAnimation()

function initTrustBoxAnimation() {

  const reviewsBlocks = Array.from(document.querySelectorAll('.js-reviews'))

  reviewsBlocks.forEach(reviewsBlock => {

    const trustBoxes = Array.from(reviewsBlock.querySelectorAll('.js-reviews-trustbox-wrapper'))

    if (trustBoxes.length > 0) {
      trustBoxes.forEach(trustBox => {
        gsap.to(trustBox, {opacity: 1, duration: 0.4});
      })
    }

  })
}
initTrustBoxAnimation()

